module.exports = __webpack_public_path__ + "media/images/icons/phone-49ca85609732e3ca130bbd1cc61bfa72.svg";